import { Space } from 'antd';
import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { HolderDots } from '../../../components/Svg/Svg';

export const GroupCard = ({
    card,
    index,
    moveCard,
    dropCard,
    onEditCard,
    onDeleteCard,
}) => {
    const ref = useRef(null);
    const [{ handlerId }, drop] = useDrop({
        accept: 'card',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        drop(item) {
            if (item.index === item.initialIndex) {
                return;
            }
            dropCard();
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }

            const dragIndex = item.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            moveCard(dragIndex, hoverIndex);

            item.index = hoverIndex;
        },
    });
    const [{ isDragging }, drag, preview] = useDrag({
        type: 'card',
        item: () => {
            return { id: card.id, index, initialIndex: index };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const opacity = isDragging ? 0 : 1;

    const foundNames =
        card?.names?.find((el) => el.lang_code === 'en' && !!el.name) ||
        card?.names?.find((el) => !!el.name);

    return (
        <div
            ref={preview(drop(ref))}
            style={{
                opacity,
            }}
            data-handler-id={handlerId}
            className="group-card__card"
        >
            <span className="group-card__name">{foundNames?.name}</span>
            <div className="group-card__controlls">
                <Space size="small">
                    <EditOutlined onClick={() => onEditCard(card)} />
                    <DeleteOutlined onClick={() => onDeleteCard(card)} />
                </Space>
                <span
                    className="group-card__controlls--drag-button"
                    ref={drag}
                    style={{
                        cursor: isDragging
                            ? '-webkit-grabbing'
                            : '-webkit-grab',
                    }}
                >
                    <HolderDots />
                </span>
            </div>
        </div>
    );
};
